// Constants
export const REQUEST_TYPES = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  DELETE: "DELETE",
};

const API_PATH = 'api/proxy/txtsso/iam/v1';

const BASE_API_URL = process.env.REACT_APP_BASE_URL || '';

export const BASE_URL = BASE_API_URL ? `${BASE_API_URL}/${API_PATH}` : "";

// Helper to get forwardedHost for auth requests
export const getForwardedHost = () => {
  if (typeof window !== 'undefined') {
    return window.location.host;
  }
  return undefined;
};
